import { clsx } from 'clsx';
import type { Grade } from '@/types';

interface GradeBadgeProps {
  grade: Grade | null;
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
}

export function GradeBadge({ grade, size = 'sm', onClick }: GradeBadgeProps) {
  if (!grade) {
    return <span className="text-gray-600">-</span>;
  }

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-2 text-lg',
  };

  const gradeColors = {
    A: 'bg-green-500 text-white',
    B: 'bg-lime-500 text-white',
    C: 'bg-yellow-500 text-black',
    D: 'bg-orange-500 text-white',
    F: 'bg-red-500 text-white',
  };

  return (
    <span
      className={clsx(
        'rounded font-bold inline-block',
        sizeClasses[size],
        gradeColors[grade],
        onClick && 'cursor-pointer hover:opacity-80'
      )}
      onClick={onClick}
    >
      {grade}
    </span>
  );
}
